module.exports = __webpack_public_path__ + "img/pnu_gallery1.98d70b78.jpg";